module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle350mm.83e5768b.png";